import { faTable } from '@fortawesome/free-solid-svg-icons';

import AmbassadorsListPage from './pages/AmbassadorsListPage';
import CreateAmbassadorPage from './pages/CreateAmbassdorPage';
import UpdateAmbassadorPage from './pages/UpdateAmbassadorPage';

export const ambassadorRoutes = [
  {
    path: '/ambassadors',
    breadcrumb: 'Ambassadors',
    component: AmbassadorsListPage,
  },
  {
    path: '/ambassadors/create',
    breadcrumb: 'Create',
    component: CreateAmbassadorPage,
  },
  {
    path: '/ambassadors/:id',
    breadcrumb: 'Edit',
    component: UpdateAmbassadorPage,
  },
];

export const ambassadorSidebarRoutes = [
  {
    path: '/ambassadors',
    label: 'Ambassadors',
    icon: faTable,
  },
];
